<script setup>
  import ListeUtilisateursProd from '@/components/ListeUtilisateursProd.vue'
</script>

<template>
  <h1>Avancement des productions</h1>

  <div class="recap">
    <ListeUtilisateursProd/>
  </div>
</template>

<script>


export default {
  data() {
    return {

    };
  },
  methods: {
    goBack() {
      const queryParams = {
        page: this.currentPage,
        searchTerm: this.searchTerm,
      };
      this.$router.go(-1);
      this.$router.push({ query: queryParams });
    },
  }
}
</script>

<style>
</style>
